import clientApi from '~/clientApi';

export const getCreators = (agencyId?: string) =>
  agencyId
    ? clientApi.agencies.creators({
        agencyId,
        pageSize: 250,
      })
    : clientApi.creators.index({
        pageSize: 250,
        _isImpersonatingDisabled: true,
      });
